<template>
  <div class="footer_box">
    <section class="w3l-footer-29-main">
      <div class="footer-29 py-5">
        <div class="container py-lg-4">
          <div class="row footer-top-29">
            <!-- {{ fullWidth }} -->
            <div
              class="col-lg-2 col-md-6 col-sm-7 footer-list-29 footer-1 pr-lg-5 mycss_footer_logo"
            >
              <div class="footer-logo mb-3">
                <a style="font-size: 16px" class="navbar-brand" href="/"
                  >广东万泰科创药业有限公司</a
                >
              </div>
              <div class="main-social-footer-29 mt-4">
                <img style="width: 100%" :src="companyInfo.qrCode" />
                <span
                  style="
                    text-align: center;
                    display: inline-block;
                    width: 100%;
                    line-height: 50px;
                    color: #fff;
                  "
                  >关注我们</span
                >
              </div>
            </div>
            <!-- {{fullWidth}} -->
            <template v-if = "fullWidth">
              <div  v-for="(item, index) in menuList"
              :key="index"
              class="
                col-lg-1 col-md-6 col-sm-5 col-6
                footer-list-29 footer-6
                mt-sm-0 mt-5
              "
            >
              <ul v-show="index != 0">
                <h6 class="footer-title-29">{{ item.menuName }}</h6>
                <li v-for="(items, id) in item.children" :key="id">
                  <router-link
                    :to="'/' + item.path + '?selectid=' + items.path"
                  >
                    {{ items.menuName }}
                  </router-link>
                </li>
              </ul>
            </div>
            </template>
            

            <div
              class="
              mycsscont
                col-lg-4 col-md-6 col-sm-7
                footer-list-29 footer-4
                mt-lg-0 mt-5
              "
            >
              <h6 class="footer-title-29">联系方式</h6>
              <p><strong>地址 :</strong> {{ companyInfo.companyAddress }}</p>
              <p class="my-2">
                <strong>电话 :</strong>
                <a :href="companyInfo.companyPhone">
                  {{ companyInfo.companyPhone }}</a
                >
              </p>
              <p>
                <strong>邮箱 :</strong>
                <a :href="companyInfo.companyEmail">{{
                  companyInfo.companyEmail
                }}</a>
              </p>
              
            </div>
            
          </div>
        </div>
      </div>
    </section>
    <!-- //footer -->

    <!-- copyright -->
    <section class="w3l-copyright">
      <div class="container">
        <div class="row bottom-copies">
          <p
            style="margin: auto; text-align: center"
            class="col-lg-6 copy-footer-29"
          >
            Copyright &copy; 2021.广东万泰科创药业有限公司 All rights reserved.
          </p>
          <p
            style="margin: auto; text-align: center"
            class="col-lg-8 copy-footer-29"
          >
            <a
              target="_blank"
              href="https://beian.miit.gov.cn/#/Integrated/index"
              >{{ companyInfo.icpNum }}</a
            >

            互联网药品信息服务许可证：
            <a target="_blank" :href="companyInfo.licencePic">{{
              companyInfo.licenceNum
            }}</a>
          </p>
          <p
            style="margin: auto; text-align: center"
            class="col-lg-8 copy-footer-29"
          >
            <a target="_blank" :href="companyInfo.businessLicense"
              >营业执照公示</a
            >
          </p>
          <p
            style="margin: auto; text-align: center"
            class="col-lg-8 copy-footer-29"
          >
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44200002444817"
              style="
                display: inline-block;
                text-decoration: none;
                height: 20px;
                line-height: 20px;
              "
              ><img
                src="http://www.beian.gov.cn/img/ghs.png"
                style="float: left"
              />
              <p
                style="
                  float: left;
                  height: 20px;
                  line-height: 20px;
                  margin: 0px 0px 0px 5px;
                  color: #939393;
                "
              >
                粤公网安备 44200002444817号
              </p></a
            >
          </p>
        </div>
      </div>

      <!-- 返回顶部按钮 -->
      <button onclick="topFunction()" id="movetop" title="Go to top">
        <i class="iconfont icon-4fanhuidingbucheng"></i>
      </button>
    </section>
  </div>
</template>

<script>
import { listMenu } from "@/api/menu/index.js";
import { listCompanyInfo } from "@/api/companyInfo/companyInfo.js";
export default {
  data() {
    return {
      menuList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 1,
      },
      companyInfo: {},
      fullWidth: true,
    };
  },
  created(){
    if(document.documentElement.clientWidth <= 1280){
          this.fullWidth = false; // 宽
        }else{
          this.fullWidth = true;
        }
  },

  mounted() {
    this.getMenuList();
    this.getCompanyInfo();

    let that = this;
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        // that.windowHeight = window.fullHeight; // 高
        if(window.fullWidth < 1280){
          that.fullWidth = false; // 宽
        }else{
          that.fullWidth = true;
        }
        
      })();
    };
  },
  methods: {
    getMenuList() {
      listMenu().then((res) => {
        this.menuList = this.handleTree(res.rows, "id");
      });
    },
    jump(bigPath, litPath) {
      if (this.$route.path !== "/" + bigPath) {
        this.$router.push({
          path: bigPath,
          params: {
            selectId: litPath,
          },
        });
      }
    },
    getCompanyInfo() {
      listCompanyInfo(this.queryParams).then((res) => {
        this.companyInfo = res.rows[0];
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 1200px) {
  .container {
    width: 100%;
  }

}
</style>